exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscription-ui-module{font-size:1em;border-radius:5px;background-color:#fff;box-shadow:0 0 0 0px rgba(63,63,68,.05),0 1px 3px 0 rgba(63,63,68,.15);margin-bottom:20px}.prompt-text{font-size:1.5em}.price{font-size:2.75em}.scrollbox{overflow-y:scroll;max-height:250px;border:1px solid #ddd;padding:5px}#multiline-button{white-space:normal}.padding-left-0-for-inner-span span{padding-left:0px !important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/my-account/myAccount.scss
// module id = 4298
// module chunks = 0